var canvas = document.getElementById("bg-storm");
var swstm = canvas.getContext("2d");
var objvmt = 43;
var objcnb = [];
var stgW = 1980;
var stgH = 180;
var vfsaMax = 1.5;
var vfsaMin = 0.2;
var imgStdW = 15;
var imgStdH = 20;
var speedMax = 0.7;
var speedMin = 0.2;
var spnxAdd = 3;
var img = new Image();
img.src = "/assets-202102/img/cmn-autumn/bg-fubuki.png";
img.onload = flow_start;
var vfsa = 0;
var soIs = 0;
var msfwn = Math.PI / 180;
var cos = 0;
var sin = 0;

function setImagas() {
  for (var i = 0; i < objvmt; i++) {
	vfsa = Math.random() * (vfsaMax - vfsaMin) + vfsaMin;
	objcnb.push({
	  'startx': Math.random() * stgW,
	  'starty': Math.random() * stgH,
	  'imgsizeW': imgStdW * vfsa,
	  'imgsizeH': imgStdH * vfsa,
	  'downS': Math.random() * (speedMax - speedMin) + speedMin,
	  'rotateObj': Math.random() * 360,
	});
  }
}

function flow() {
  swstm.clearRect(0, 0, stgW, stgH);
  for (soIs = 0; soIs < objvmt; soIs++) {
	objcnb[soIs].starty += objcnb[soIs].downS;
	objcnb[soIs].rotateObj += Math.random() * spnxAdd;
	cos = Math.cos(objcnb[soIs].rotateObj * msfwn);
	sin = Math.sin(objcnb[soIs].rotateObj * msfwn);
	swstm.setTransform(cos, sin, sin, cos, objcnb[soIs].startx, objcnb[soIs].starty);
	swstm.drawImage(img, 8, 5, objcnb[soIs].imgsizeW, objcnb[soIs].imgsizeH);
	swstm.setTransform(1, 0, 0, 1, 0, 0);
	swstm.setTransform(1, 0, 0, 1, 0, 0);
	if (objcnb[soIs].starty >= stgH) {
	  objcnb[soIs].starty = -objcnb[soIs].imgsizeH;
	}
  }
}

function flow_start() {
  setImagas();
  setInterval(flow, 10);
}
